/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { loadTranslations } from '../i18n'; // Import loadTranslations function
import { isMobile, isTablet } from 'react-device-detect';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';

import { decodeToken, getToken } from '../utils/TokenUtils';
import ModalForm from './ModalForm';
import '../css/navbar.css';
import FeatherIcon from 'feather-icons-react';
import TopNavbarStatement from './TopNavbarStatement';
import { notification } from 'antd';
import InfoModal from './InfoModal';
const MyNavbar = () => {
  const [screenSize, setScreenSize] = useState('large'); // Track screen size
  const { t } = useTranslation();
  const [showNotifications, setShowNotifications] = useState(false);
  // True only for mobile phones (not tablets like iPad)
  const isPhone = isMobile && !isTablet;

  useEffect(() => {
    // Load the translations from the API (replace 'en' with your desired language code)
    loadTranslations(); // Load English translations (or any other language)
  }, []);
  const navigate = useNavigate();
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const userImage = decodeToken(token, 'image');
  const userEmail = decodeToken(token, 'email');
  const userName = decodeToken(token, 'name');
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  const loginPage = decodeToken(token, 'loginPage');
  const userType = decodeToken(token, 'userType');
  const userlevel = decodeToken(token, 'userLevel');
  const dashboardPage = decodeToken(token, 'dashboardPage');

  const passwordExpireLeft = decodeToken(token, 'passwordExpireLeft');
  const [isNavBarOpen, setIsNavBarOpen] = useState(false);
  const [isNavBarOpen2, setIsNavBarOpen2] = useState(false);

  const [filteredLinks, setFilteredLinks] = useState(false);
  const [activeCategory, setActiveCategory] = useState();

  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unreadNotications, setUnreadNotifications] = useState(0);
  const [selectedNotification, setSelectedNotification] = useState({});
  // Fetch data from the server when the query changes
  useEffect(() => {
    if (query.length === 0) {
      setResults([]);
      return;
    }

    if (!token) {
      navigate('/login/user-login');
    }
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/search-link?query=${query}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        //  console.log(response.data);
        setResults(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [query]);

  const handleSelectedNotification = async (id, index) => {
    const payload = {
      notification_id: id,
      read_user_id: userId,
      user_level: userlevel,
    };
    const url = `${API_URL}/${ENDPOINTS.SYS}/create/make-read-message`;
    await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setShowNotifications(false);
    console.log('index nof: ', notifications[index]);
    setSelectedNotification(notifications[index]);
  };
  useEffect(() => {
    if (selectedNotification?.id && userlevel == 'developer') {
      console.log('Updated selectedNotification:', selectedNotification);
      // You can also open a modal or do other logic here
    }
  }, [selectedNotification]);
  useEffect(() => {
    if (!token) {
      navigate('/login/user-login');
    }
    const fetchNotification = async () => {
      setLoading(true);

      try {
        console.log('user level: ', userlevel);
        const response = await axios.post(
          `${API_URL}/${ENDPOINTS.SYS}/reportCustom/unread-notifications`,
          {
            user_level: userlevel,
            user_id: userId,
          },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        console.log('response: ', response.data);
        console.log(response.data.data);

        setNotifications(response.data.data);
        setUnreadNotifications(response.data.data[0].count || 0);
      } catch (error) {
        console.error('Error fetching Notification:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotification();
  }, [selectedNotification]);
  // Toggle navbar
  const toggleNavbar = () => {
    setIsNavBarOpen(!isNavBarOpen);
  };

  // Toggle navbar
  const toggleNavbar2 = () => {
    setIsNavBarOpen2(!isNavBarOpen2);
  };

  // Close navbar when a link is clicked
  const closeNavbar = () => {
    console.log('Clicked/Closed');
    setIsNavBarOpen(false);
  };

  // Close navbar when a link is clicked
  const closeNavbar2 = () => {
    console.log('Clicked/Closed');
    setIsNavBarOpen2(false);
  };

  // Function to handle path navigation and category filtering
  const handleNavigation = (e, category, path) => {
    e.preventDefault();
    closeNavbar();

    // Filter the links based on the selected category_id
    const filteredLinks = links.filter(
      (link) => link.category_id === category.category_id
    );

    // Set the active category state
    setActiveCategory(category);
    setFilteredLinks(filteredLinks);
    // Navigate to the new path
    navigate(path);

    // Optionally, log the filtered links if needed for debugging
    // console.log(path);
    //  console.log(filteredLinks);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({
    userId: null,
    token: null,
    route: null,
  });

  const onClickSearch = (e, path, route, tab) => {
    e.preventDefault();
    setQuery('');
    setResults([]);
    // console.log(path, route);
    if (path.includes('-modal/')) {
      setModalProps({ userId, token, route });
      setIsModalOpen(true);
    } else {
      // Navigate to the new path
      if (tab === 'new-tab') {
        const fullPath = path.startsWith('http')
          ? path
          : `${window.location.origin}/${path}`;
        window.open(fullPath, '_blank', 'noopener,noreferrer');
      } else {
        navigate(path);
      }
    }
  };

  // console.log(token);
  // Function to open the modal with dynamic props
  const handleOpenModal = (e, route) => {
    e.preventDefault();

    setModalProps({ userId, token, route });
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [categories, setCategories] = useState([]);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const linksUrl = `${API_URL}/${ENDPOINTS.SYS}/get-categories`;
    const languagesUrl = `${API_URL}/${ENDPOINTS.USER}/get-languages`;

    const fetchLinks = async (url) => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        // setLinks(groupBy(response.data, 'category'));
        setCategories(response.data.categories);
        setLinks(response.data.links);

        //  console.log(response.data);
      } catch (error) {
        // console.log('error:', error);
        // Displaying a notification with the status code and message
        notification.error({
          message: `Error ${error?.response?.status}: ${error?.response?.data.message || 'Unknown error'}`,
        });
        console.log('Error fetching links ', error);
      }
    };
    const fetchLanguages = async (url) => {
      try {
        const response = await axios.get(url);

        // setLinks(groupBy(response.data, 'category'));
        setLanguages(response.data);

        //  console.log(response.data);
      } catch (error) {
        // console.log('error:', error);
        // Displaying a notification with the status code and message
        notification.error({
          message: `Error ${error?.response?.status}: ${error?.response?.data.message || 'Unknown error'}`,
        });
        console.log('Error fetching links ', error);
      }
    };

    fetchLinks(linksUrl);
    fetchLanguages(languagesUrl);
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${API_URL}/api/users/logout`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      //  console.log('res', response, 'token:', token);

      // Remove token from localStorage
      localStorage.removeItem('authToken');
      navigate(`/login/${loginPage}`);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Remove token from localStorage

      //  localStorage.removeItem("token");
      //  navigate("/login");
    }
  };

  // Function to handle screen resize
  const handleResize = () => {
    if (window.innerWidth < 576) {
      setScreenSize('small'); // Extra small screens
    } else if (window.innerWidth < 1592) {
      setScreenSize('medium'); // Medium screens
    } else {
      setScreenSize('large'); // Large screens (992px and above)
    }
  };

  useEffect(() => {
    handleResize(); // Set the initial state
    window.addEventListener('resize', handleResize); // Listen to resize events
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to split links into two parts: main links and dropdown links
  const splitLinks = () => {
    if (screenSize === 'large') {
      return {
        mainLinks: categories,
        dropdownLinks: [],
      };
    }
    if (screenSize === 'medium') {
      const mainLinks = categories.slice(0, 8);
      const dropdownLinks = categories.slice(8);

      return { mainLinks, dropdownLinks };
    }
    const mainLinks = categories.slice(0, 5);
    const dropdownLinks = categories.slice(5);

    return { mainLinks, dropdownLinks };
  };

  const { mainLinks, dropdownLinks } = splitLinks();

  const language = localStorage.getItem('language');
  const handleLanguageChange = (event) => {
    localStorage.setItem('language', event.target.value); // Save selected language in localStorage

    //loadTranslations(); // Load English translations (or any other language)
    //reload();
    window.location.reload();
  };

  return (
    <>
      <div className="fixed-top">
        <nav className="navbar top-navbar ">
          <TopNavbarStatement />
          <select className="language-dropdown" onChange={handleLanguageChange}>
            {languages &&
              languages?.map((lang) => (
                <option
                  key={lang.id}
                  value={lang.id}
                  selected={language === lang.id}
                >
                  {t(lang.name)}
                </option>
              ))}

            {/* Add more languages as needed */}
          </select>
        </nav>
        <nav className="navbar navbar-expand-lg navbar-light bg-light ">
          <div className="container-fluid">
            <img
              src={`${API_URL}/${companyLogo}`}
              width="50px"
              alt="Company Logo"
              className="rounded-circle"
            />{' '}
            &nbsp;
            <a className="navbar-brand" href={dashboardPage}>
              {companyName}
            </a>
            {userType === 'user' && (
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control" // Bootstrap class for styling
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search..."
                  style={{
                    width: '100%', // Ensure it matches the container width
                  }}
                />
                {/* {loading && <div>Loading...</div>} */}
                {results && results.length > 0 && (
                  <ul
                    className="list-group position-absolute"
                    style={{
                      margin: 0,
                      top: '100%',
                      width: '100%',
                      zIndex: 1,
                      maxHeight: '550px', // Limit height
                      overflowY: 'auto', // Add vertical scroll
                      border: '1px solid #ccc', // Add border for better visibility
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                    }}
                  >
                    {results.map((item, index) => (
                      <li
                        className="list-group-item"
                        key={index}
                        style={{
                          padding: '8px',
                          cursor: 'pointer',
                        }}
                      >
                        <small>
                          {/* {item.name} */}
                          {t(item.name)}
                          {/* <span className="badge bg-danger">
                            {' '}
                            {item?.description}
                          </span> */}
                        </small>
                        <br />
                        <a
                          href="/"
                          onClick={(e) =>
                            onClickSearch(
                              e,
                              item.full_route,
                              item.route,
                              'current-tab'
                            )
                          }
                        >
                          Click
                        </a>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <a
                          href="/"
                          onClick={(e) =>
                            onClickSearch(
                              e,
                              item.full_route,
                              item.route,
                              'new-tab'
                            )
                          }
                        >
                          New Tab
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleNavbar}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`collapse navbar-collapse ${isNavBarOpen ? 'show' : ''}`}
              id="navbarNav"
            >
              {' '}
              <ul className="navbar-nav">
                {mainLinks &&
                  mainLinks.map((link, index) => (
                    <li className={`nav-item `} key={index}>
                      <Link
                        className={`nav-link ${activeCategory?.category_id === link.category_id ? 'active' : ''}`} // Add 'active' class if category IDs match
                        href="/"
                        onClick={(e) =>
                          handleNavigation(e, link, `/${link.full_route}`)
                        } // Adjust the path accordingly
                      >
                        <FeatherIcon icon={link.category_icon} />{' '}
                        {t(link.category)}
                      </Link>
                    </li>
                  ))}
              </ul>
              {/* User Profile Dropdown */}
              <ul className="navbar-nav ms-auto">
                <li className="nav-item dropdown position-relative">
                  <a
                    href="#"
                    className="nav-link position-relative"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowNotifications(!showNotifications);
                    }}
                    title="Notifications"
                  >
                    <FeatherIcon icon="bell" className="me-1" />
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{ fontSize: '0.6rem' }}
                    >
                      {unreadNotications}
                    </span>
                  </a>

                  {showNotifications && notifications && (
                    <div
                      className="dropdown-menu show position-absolute mt-2"
                      style={{ right: 0, minWidth: '250px', zIndex: 1000 }}
                    >
                      {notifications?.map((notification, index) => (
                        <button
                          className="dropdown-item"
                          onClick={() =>
                            handleSelectedNotification(notification.id, index)
                          }
                        >
                          {notification.title}
                        </button>
                      ))}
                    </div>
                  )}
                </li>

                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/"
                    id="userDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={`${API_URL}/${userImage}`}
                      alt="User"
                      className="rounded-circle"
                      style={{ width: '30px', height: '30px' }}
                    />{' '}
                    &nbsp;&nbsp;
                    {userName}
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="userDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/profile">
                        {t('Profile')}
                      </Link>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="/"
                        onClick={(e) => handleOpenModal(e, 'change-password')}
                      >
                        {t('Change Password')}
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="/logout"
                        onClick={(e) => handleLogout(e)}
                      >
                        {t('Logout')}
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    {userlevel === 'developer' && (
                      <li>
                        <a
                          className="dropdown-item"
                          // href={`#${API_URL}/${ENDPOINTS.SYS}/backup`}
                          href="/dashboard"
                          // target="_blank"
                          rel="noreferrer"
                          // onClick={(e) => handleLogout(e)}
                        >
                          Backup
                        </a>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br /> <br />
      {isPhone && (
        <>
          <br />
          <br />
          <br />
          <br />
          <br />
        </>
      )}
      {filteredLinks && (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container-fluid">
            <a className="navbar-brand" href="/dashboard">
              {t(activeCategory.category)}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav2"
              aria-controls="navbarNav2"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleNavbar2}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`collapse navbar-collapse ${isNavBarOpen2 ? 'show' : ''}`}
              id="navbarNa2v"
            >
              {' '}
              <ul className="navbar-nav">
                {/* Render the "Others" category links */}
                {filteredLinks
                  .filter((link) => link.sub_category === 'Others') // Filter only the 'Others' sub_category links
                  .map((link, index) => (
                    <li className="nav-item" key={index}>
                      <Link
                        className="nav-link text-white fw-bold"
                        to={`/${link.full_route}`}
                        onClick={closeNavbar2}
                      >
                        {/* <FeatherIcon icon={link.icon} /> */}
                        {/* {link.name} */}
                        {t(link.name)}
                      </Link>
                    </li>
                  ))}

                {/* Render dropdowns for other subcategories */}
                {filteredLinks
                  .filter(
                    (link, index, self) =>
                      self.findIndex(
                        (t) => t.sub_category === link.sub_category
                      ) === index && link.sub_category !== 'Others' // Ensure unique sub_category, excluding 'Others'
                  )
                  .map((link, index) => (
                    <li className="nav-item dropdown" key={index}>
                      <a
                        className="nav-link dropdown-toggle text-white fw-bold"
                        href="/"
                        id={`navbarDropdown-${link.sub_category}`}
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {t(link.sub_category)}{' '}
                        {/* Dropdown title is sub_category */}
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`navbarDropdown-${link.sub_category}`}
                      >
                        {filteredLinks
                          .filter(
                            (subLink) =>
                              subLink.sub_category === link.sub_category
                          ) // Filter links by sub_category
                          .map((subLink, subIndex) => (
                            <li key={subIndex}>
                              <Link
                                className="dropdown-item"
                                to={`/${subLink.full_route}`}
                                onClick={closeNavbar2}
                              >
                                {/* <FeatherIcon icon={subLink.icon} /> */}
                                {/* {subLink.name} */}
                                {t(subLink.name)}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </nav>
      )}
      {passwordExpireLeft !== null && passwordExpireLeft < 15 && (
        <p className="text-danger text-center fw-bold">
          <marquee>
            Your password will expire soon, it only remains {passwordExpireLeft}{' '}
            days, please{' '}
            <a href="/" onClick={(e) => handleOpenModal(e, 'change-password')}>
              change
            </a>{' '}
            it before expires.
          </marquee>
        </p>
      )}
      {selectedNotification?.id && (
        <InfoModal
          title={selectedNotification.title}
          info={selectedNotification.message}
          onclose={() => setSelectedNotification({})}
        />
      )}
      {/* ModalForm component */}
      {modalProps?.route && (
        <ModalForm
          userId={modalProps.userId}
          token={modalProps.token}
          route={modalProps.route}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}
    </>
  );
};

export default MyNavbar;
